export var CONTRACTS = {
  fortnight: {
    title: 'Fortnightly contract',
    description: 'Fortnightly contract refers to a contract type where you are charged per fortnight booked.',
    urlPath: 'fortnightly'
  },
  monthly: {
    title: 'Monthly contract',
    description: 'Monthly contract refers to a contract type where full months are charged.',
    urlPath: 'monthly'
  },
  nightly: {
    title: 'Daily contract',
    description: 'Daily contract refers to a contract type where your rents are calculated in proportion to the days of your stay.',
    urlPath: 'daily'
  },
  fixed: {
    title: 'Fixed contract',
    description: 'Fixed contract refers to a contract type with fixed start and end dates, defined by the landlord.',
    urlPath: 'fixed'
  }
};